let labels: Record<string, string> = {
  fb: 'Facebook',
  facebook: 'Facebook',
  ig: 'Instagram',
  instagram: 'Instagram',
  yt: 'YouTube',
  youtube: 'YouTube',
  tt: 'TikTok',
  tiktok: 'TikTok',
  twitter: 'Twitter',
  x: 'X',
}

let E: Record<string, any> = {}
export default E

E.platform_lbl = (platform: string): string => {
  if (!platform)
    return ''
  return labels[platform.toLowerCase()]
    || platform.charAt(0).toUpperCase() + platform.slice(1)
}


E.payout_est = (s: {med_views?: number, avg_views?: number,
  cpm?: number}): number => {
  let views = s.med_views ?? s.avg_views ?? 0
  return views/1000*(s.cpm || 0)
}